import React from 'react'
import { DEFAULT_LOADERS } from '../constants/DEFAULT_LOADERS'
import { useSelector } from 'react-redux'
import { getAccountSettingsPreloader } from '../lib/projectAxios'

const FlagPath = ['project', 'Settings', 'ui', 'useCustomLoader']
const ImgPath = ['project', 'Settings', 'theme', 'lg', 'sfPreloaderMsg', 'icon', 'backgroundImage']

export const PageLoader = ({ style }) => {
  const useCustomLoader = useSelector(
    (state) => state.getIn(FlagPath, false) || _.get(window, ['__FT__APP__STATE', ...FlagPath], false)
  )
  const customLoaderImage = useSelector(
    (state) => state.getIn(ImgPath) || _.get(window, ['__FT__APP__STATE', ...ImgPath], DEFAULT_LOADERS[0].path)
  )
  const preloaderUrl = getAccountSettingsPreloader()
  return (
    <div
      style={Object.assign(
        {
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'transparent',
        },
        style || {}
      )}
      className="ft-loading-animation">
      {useCustomLoader && customLoaderImage ? (
        <img src={customLoaderImage} alt="loader image" width={53} height={48} />
      ) : preloaderUrl ? (
        <img src={preloaderUrl} alt="loader image" width={53} height={48} />
      ) : (
        <svg width={53} height={48} xmlns="http://www.w3.org/2000/svg">
          <g fill="none" fillRule="evenodd">
            <path
              d="M50.215 16l.352.497a13.167 13.167 0 010 15.252L39.27 47.691a.735.735 0 01-.6.309h-8.939a.733.733 0 01-.65-.39.716.716 0 01.05-.749l19.83-27.981A7.657 7.657 0 0050.215 16z"
              fill="#E011AC"
            />
            <path
              d="M38.705 0c.24 0 .465.116.602.311l7.73 10.962a5.32 5.32 0 01-.012 6.122L43.778 22c-.1-.199-.216-.39-.345-.572l-14.3-20.28a.725.725 0 01-.05-.755.736.736 0 01.652-.393h8.97z"
              fill="#3FD736"
            />
            <path
              d="M9.222 26c.1.199.216.39.345.572l14.3 20.28a.725.725 0 01.05.755.736.736 0 01-.652.393h-8.97a.736.736 0 01-.602-.311l-7.73-10.962a5.32 5.32 0 01.011-6.122L9.222 26z"
              fill="#FF6550"
            />
            <path
              d="M4.04 29.121A7.658 7.658 0 002.784 32l-.352-.497a13.168 13.168 0 010-15.252L13.73.309a.735.735 0 01.6-.309h8.939c.273 0 .523.15.65.39a.716.716 0 01-.05.749L4.039 29.12z"
              fill="#10DDE5"
            />
          </g>
        </svg>
      )}
    </div>
  )
}
